<template>
  <div>
    <div class="mb-2">
      <strong class="mr-2">{{name}}</strong>
    </div>
    <div v-if="values.length > 0">
      <div v-for="item in values" :key="'value-' + item.id">
        <span v-if="linkable"><b-link :to="{ name: linkRouteName, params: { id: item.id }}">{{item.name}}</b-link></span>
        <span v-if="!linkable">{{item[nameProperty]}}</span>
        <b-button class="mx-2" variant="outline-primary" size="sm" v-on:click="deleteEdge(item)">remove</b-button>
      </div>
    </div>
    <b-form inline>
      <b-form-input class="mr-2" v-model="searchInput" placeholder="search term" />
    </b-form>
    <div v-if="loading">
      <span><i class="fa fa-spinner fa-pulse fa-lg fa-fw"></i></span>
    </div>
    <div v-if="searchOutput != null & !loading">
      <div v-for="item in searchOutput" :key="'search'+item.id">
        <b-link v-on:click="assign(item)">{{item.name}}</b-link>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'ExpertLookup',
  props: {
    labelDelField: String,
    labelLinkingField: String,
    labelModel: String,
    linkingModel: String,
    linkable: {
      type: Boolean,
      default: false
    },
    linkRouteName: {
      type: String,
      default: ''
    },
    name: String,
    parentId: Number,
    parentLinkingField: String,
    relation: String
  },
  computed: {
    experts: {
      get () {
        return this.$store.state.experts
      },
      set (payload) {
        this.$store.commit('setExperts', payload)
      }
    },
    user: {
      get () {
        return this.$store.state.user
      }
    },
    validate: function () {
      return this.selected
    }
  },
  created: async function () {
    if (this.experts.length === 0) {
      try {
        const experts = await this.$Amplify.API.get('cosmos', '/standard/impactexpert')
        _.each(experts, x => {
          const searchString = x.surname + ' ' + x.forename + ' ' + x.surname
          x.searchString = searchString.toUpperCase()
        })
        this.experts = experts
      } catch (e) {
        console.log(e)
      }
    }
    this.loadEdges()
  },
  data () {
    return {
      busy: false,
      edit: false,
      loading: true,
      searchInput: '',
      searchOutput: null,
      values: []
    }
  },
  methods: {
    search: function () {
      this.$logger.debug('buildOptions start')
      const db = _.filter(this.experts, x => {
        return x.searchString.includes(this.searchInput.toUpperCase())
      })
      this.searchOutput = _.differenceBy(db, this.values, 'id')
    },
    deleteEdge: async function (value) {
      this.$logger.debug('deletePropertyList started')
      this.loading = true
      try {
        // let response = await this.$http(config)
        let apiName = 'cosmos'
        let path = `/standard/relationship/${this.linkingModel}`
        let params = {
          body: {
            left: { column: this.parentLinkingField, id: this.parentId },
            right: { column: this.labelLinkingField, id: value.id }
          }
        }
        let response = await this.$Amplify.API.del(apiName, path, params)
        this.$stat.log({ action: 'unlinked property', model: this.linkingModel, payload: params.body })
        this.$logger.debug('deleted OK:', response)
        let temp = this.values
        _.pull(temp, value)
        this.values = temp
      } catch (e) {
        this.$logger.warn('delete error: ' + e)
      }
      this.loading = false
    },
    loadEdges: async function () {
      this.$logger.debug('loadEdges started')
      this.loading = true
      let labelDelField = 'no-del'
      if (this.labelDelField) {
        labelDelField = this.labelDelField
      }
      let path = `/standard/relation/${this.labelModel}/${this.parentId}/${this.relation}/${this.parentLinkingField}/${labelDelField}`
      try {
        this.values = await this.$Amplify.API.get('cosmos', path)
        this.$logger.debug('load values', this.values)
        this.loading = false
      } catch (e) {
        this.$logger.warn('/topic/:id error', e)
      }
    },
    assign: async function (item) {
      this.$logger.debug(`saveEdge start`)
      this.loading = true
      try {
        // let response = await this.$http(config)
        const apiName = 'cosmos'
        const path = `/standard/relationship/${this.linkingModel}`
        const params = {
          body: {
            left: { column: this.parentLinkingField, id: this.parentId },
            right: { column: this.labelLinkingField, id: item.id },
            username: this.user.username
          }
        }
        const response = await this.$Amplify.API.put(apiName, path, params)
        this.$stat.log({ action: 'linked new property', model: this.linkingModel, model_id: response.id, payload: response })
        this.$logger.debug('saved OK:', response)
        const newItem = {}
        newItem.id = item.id
        newItem.name = item.name
        this.values.push(newItem)
        this.searchOutput = null
        this.searchInput = null
      } catch (e) {
        this.$logger.warn('event saving error: ' + e)
      }
      this.loading = false
    }
  },
  watch: {
    searchInput: function () {
      if (this.searchInput && this.searchInput.length > 1) {
        this.search()
      }
      if (!this.searchInput || this.searchInput.length < 2) {
        this.searchOutput = null
      }
    }
  }
}
</script>

<style>
</style>
